'use client';

import React, { PropsWithChildren } from 'react';

import styled from '@emotion/styled';
import { useMediaQuery } from '@mui/material';

const LeatherTextContainer = styled.div<{
  isMobile: boolean;
  isRugby: boolean;
}>`
  position: absolute;
  top: ${(props) => (props.isRugby ? '42%' : props.isMobile ? '31%' : '24%')};
  left: 26%;
  transform: translate(-50%, -50%);
  font-family: opensans, sans-serif;
  font-size: ${(props) =>
    props.isMobile ? 'clamp(5px, 2vw, 7px)' : 'clamp(8px, 2.5vw, 12px)'};
  font-weight: 900;
  text-transform: uppercase;
  text-align: center;
  width: ${(props) => (props.isMobile ? '22%' : '16.67%')};
  word-wrap: break-word;
  letter-spacing: 1px;
  color: #bb934b;
`;

type LeatherTextProps = PropsWithChildren<{
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  isRugby?: boolean;
}>;

export const LeatherText = ({
  children,
  className,
  style,
  isRugby = false,
}: LeatherTextProps) => {
  const isMobile = useMediaQuery('(max-width:768px)');

  return (
    <LeatherTextContainer
      className={className}
      style={style}
      isMobile={isMobile}
      isRugby={isRugby}
    >
      {children}
    </LeatherTextContainer>
  );
};
